var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "pb-10 mb-10" }, [
    _c("img", {
      staticClass: "mr-10",
      attrs: { src: "/static/icon-boleto.svg", height: "45px" }
    }),
    _vm._v(" "),
    _c("div", { staticClass: "data" }, [
      _c("div", { staticClass: "header" }, [
        _c("b", [_vm._v("Pagamento por Boleto")]),
        _vm._v(" "),
        _c("div", { staticClass: "status" }, [
          _vm.state
            ? _c(
                "div",
                { staticClass: "label", class: "bg-" + _vm.state.color },
                [_vm._v(_vm._s(_vm.state.name))]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.payment.funding_instrument.url_print
            ? _c(
                "a",
                {
                  staticClass: "btn btn-small bg-purple-outline",
                  attrs: {
                    href: _vm.payment.funding_instrument.url_print,
                    target: "_blank",
                    rel: "noopener noreferrer"
                  }
                },
                [
                  _c("img", {
                    attrs: { src: "/static/icon-download.svg", height: "10px" }
                  }),
                  _vm._v(" download\n        ")
                ]
              )
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _vm.payment.funding_instrument.line_code
        ? _c("div", { staticClass: "line-code" }, [
            _c("div", { staticClass: "mr-5", attrs: { id: "line_code" } }, [
              _vm._v(_vm._s(_vm.payment.funding_instrument.line_code))
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-small bg-purple-outline",
                on: { click: _vm.copy }
              },
              [
                _c("img", {
                  staticClass: "mr-5",
                  attrs: { src: "/static/icon-copy.svg", height: "10px" }
                }),
                _vm._v("copiar\n      ")
              ]
            )
          ])
        : _c("div", { staticClass: "line-code" }, [
            _vm._v("Não foi gerada uma linha digitável para este pagamento.")
          ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b087c912", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b087c912","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Shared/PaymentHistory/Boleto.vue
// module id = null
// module chunks = 